import { isEqual } from 'lodash';

function compare(value1, value2) {
    return isEqual(value1, value2);
}

export const comparatorUtils = {
    compare,
};
